<template>

  <div class="modal fade" id="AddRapportInventaireModal" tabindex="-1" role="dialog" ref="addRapportInventaireModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title">{{ title }}</h4>
                      <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <Form ref="rapportInventaireForm" @submit="addRapportInventaire" :validation-schema="rapportInventaireSchema">
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Motif <span class="text-danger">*</span>
                            </label>
                            <Field name="motif" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le motif"/>
                            <ErrorMessage name="motif" class="text-danger"/>
                          </div>
                        </div>

                        <div class="col-md-6">
                      <label for="fileInput">Sélectionnez un fichier (.pdf, .doc, .docx) :</label>
                      <input id="fileInput" type="file" @change="onFileChange" accept=".pdf,.doc,.docx" class="form-control" />
                    </div>
                 
                  <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                        <button
                          ref="submitButton"
                          class="btn btn-primary"
                          type="submit">
                          {{ btntext }}
                        </button>
                      </div>
                    </Form>
                  </div>
                  <!-- <div class="modal-footer">
                      <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                      <button class="btn btn-primary" type="button">Save changes</button>
                  </div> -->
              </div>
          </div>
      </div>
  </template> 
  
  <script lang="ts">
  import { ref, watch } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, hideModal, success } from '@/utils/utils';
  import { useRouter } from 'vue-router';
  import { RapportInventaire } from '@/models/RapportInventaire';
  
  export default {
    name: "AddRapportInventaireModal",
    components: {
      Form,
      Field,
      ErrorMessage
    },
    props:{
      id: {
        type: Number,
        required: true,
        default:0
      },
    },
    emits: ["refreshRapportInventaire",'openmodal'],
  
    setup: (props:any, { emit }: { emit: Function }) => {
  
      const loading = ref<boolean>(false);
      const rapportInventaireSchema = Yup.object().shape({
        motif: Yup.string().required('Le motif est obligatoire'),
        fichierRapport: Yup.string().required('Le fichier est obligatoire'),
      });
  
  
      const rapportInventairenew = ref(props.id);
      const rapportInventaireForm =  ref<RapportInventaire | null>(null);
      const addRapportInventaireModalRef = ref<null | HTMLElement>(null);
      const submitButton = ref<HTMLButtonElement | null>(null);
      let rapportInventaires= ref<Array<RapportInventaire>>([]);
      const title = ref('Ajouter un rapport d`\inventaire');
      const btntext = ref('Ajouter');
      const isupdate=ref(false);
      const router = useRouter();
  
      watch(() => props.id , (newValue) => {   
        if (newValue!=0) {
          getRapportInventaire(newValue);
          isupdate.value=true;
        }
        btnTitle();
      });
  
      const getRapportInventaire = async (id: number) => {
        return ApiService.get("/inventaires/"+id)
        .then(({ data }) => {
          rapportInventaireForm.value?.setFieldValue("id",data.data.id);
          rapportInventaireForm.value?.setFieldValue("nom",data.data.motif);
          rapportInventaireForm.value?.setFieldValue("description",data.data.fichierRapport);
          emit('openmodal', addRapportInventaireModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }


      const file = ref(null);
    const errorMessage = ref('');
    const maxFileSize = 5 * 1024 * 1024; // 5 Mo

    const onFileChange = (event) => {
      const selectedFile = event.target.files[0];
      const allowedExtensions = /(\.pdf|\.doc|\.docx)$/i;

      if (!allowedExtensions.test(selectedFile.name)) {
        errorMessage.value = 'Seuls les fichiers .pdf, .doc, et .docx sont autorisés.';
        return;
      }

      if (selectedFile.size > maxFileSize) {
        errorMessage.value = 'Le fichier ne doit pas dépasser 5 Mo.';
        return;
      }

      file.value = selectedFile;
      errorMessage.value = '';
    };
  
      const btnTitle = async () => {
        if (isupdate.value) {
           title.value = "Modifier le rapport d'inventaire";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un rapport d'inventaire";
           btntext.value = "Ajouter";
        }
      }
  
      const addRapportInventaire = async (values:any, {resetForm}: {resetForm: () => void  }) => {

        if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }
        values = values as RapportInventaire;
        loading.value = false;
        if(isupdate.value) {
          ApiService.put(`/inventaires/${values.id}`,values)
          .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              resetForm();
              hideModal(addRapportInventaireModalRef.value);
              isupdate.value=false;
              btnTitle();
              emit("refreshRapportInventaire");
              router.push('/inventaires/liste-inventaires');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }else{
          ApiService.post("/inventaires",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message)
              resetForm();
              hideModal(addRapportInventaireModalRef.value);
              //router.push('/permissions/liste-permission');
              emit("refreshRapportInventaire");
  
            }
          }).catch(({ response }) => {
            submitButton.value!.disabled = false;
            error(response.data.message);
          });
        }
      }; 
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isupdate.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return {rapportInventaires, title,btntext, resetValue, rapportInventaireSchema, submitButton,
         addRapportInventaire, rapportInventaireForm,addRapportInventaireModalRef,rapportInventairenew,errorMessage,onFileChange
         //refreshPermissions
         };
    },
  };
  </script>@/models/Permission